import * as React from 'react';
import * as styles from './Link.css';

interface ILinkProps {
  href?: string;
  children: React.ReactNode;
  target?: '_self' | '_blank';
  title?: string;
  rel?: string;
  onClick?(event: React.MouseEvent<HTMLAnchorElement>): void;
}

export const Link = ({ href, target, title, rel, children, onClick }: ILinkProps) => {
  return (
    <a href={href} target={target} title={title} rel={rel} className={styles['link']} onClick={onClick}>
      {children}
    </a>
  );
};
